/* APP COMPONENT **************************************************************/

/* react redux */
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'

import {fetch as fetchUser} from 'react-redux/actions/user'
import {fetch as fetchLanguage} from 'react-redux/actions/language'

import selector from './selector'

import Login from 'component/login'
import CookieOptIn from 'component/cookie-opt-in'
import Imprint from 'component/imprint'
import Navigation from 'component/navigation/navigation'
import User from 'component/user/user'
import PasswordReset from 'component/user/password-reset'
import AssetList from 'component/asset/list'
import PlaylistList from 'component/playlist/list'
import MediaPlayerList from 'component/media-player/list'
import Modal from 'component/modal/modal'
import NotificationStack from 'component/notification/stack'
import NotificationList from 'component/notification/list'
import UserProfile from 'component/user/profile'
import Filter from 'component/filter'

import * as VIEW from './view'
import { setView } from 'react-redux/actions/app'

/* Components */

/* Assets */
import logo from 'assets/logo_transparent.png'
import brandLogo from 'assets/mpura_logo.png'

/* Styles */
import "./styles.css"

/* Main React App using col layout */
class App extends Component {

  componentWillMount() {
    const { fetchUser, fetchLanguage } = this.props
    //const { applicationStartup } = this.props
    //applicationStartup()
    fetchUser()
    fetchLanguage()
  }


  renderMainPanel() {
    const { view } = this.props
    switch (view) {
      case VIEW.DASHBOARD: {
        return (
          <div className="content dashboard">
            <Filter></Filter>
            <div className="row">
              <div className="column">
                <AssetList/>
              </div>
              <div className="column">
                <PlaylistList/>
              </div>
              <div className="column">
                <MediaPlayerList/>
              </div>
            </div>
          </div>
        )
      }
      case VIEW.NOTIFICATION: {
        return (
          <div className="content">
            <div className="row">
              <div className="column">
                <NotificationList/>
              </div>
            </div>
          </div>
        )
      }
      case VIEW.USERPROFILE: {
        return (
          <div className="content">
            <UserProfile/>
          </div>
        )
      }
      case VIEW.IMPRINT: {
        return (
          <div className="content">
            <Imprint/>
          </div>
        )
      }
      return null
    }
  }

  /* Opens the about Modal */
  showLogin() {
    const { setView } = this.props
    setView(VIEW.DASHBOARD)
  }

  renderLoginLink() {
    const { t, loggedIn, view } = this.props
    if (loggedIn) return null
    let className = ["secondary-link"]
    if (view === VIEW.LOGIN) className.push("selected")
    return (
      <a
        className={ className.join(' ') }
        onClick={ this.showLogin.bind(this) }
        >
        { t('app:loginLink') }
      </a>
    )
  }

  /* Opens the about Modal */
  showImprint() {
    const { setView } = this.props
    setView(VIEW.IMPRINT)
  }

  renderImprintLink() {
    const { t, view } = this.props
    let className = ["secondary-link"]
    if (view === VIEW.IMPRINT) className.push("selected")
    return (
      <a
        className={ className.join(' ') }
        onClick={ this.showImprint.bind(this) }
      >
        { t('app:imprintLink') }
      </a>
    )
  }

  renderLogo() {
    const { t, brand } = this.props
    switch (brand.logo) {
      case "mpura":
        return <img
          className="brand-logo"
          src={ brandLogo }
        />
      default:
        return <img
         className="logo"
         src={ logo }
         alt={ t('user:login.logoAlt') }
         title={ t('user:login.logoTitle') }
       />
    }
  }

  /*

    { this.renderLoginLink() }
    { this.renderImprintLink() }
  */
  /*  onClick={  } this.showInfoModal.bind(this)*/
  renderLayout() {
    const { t, loggedIn } = this.props
    return (
      <div className="mainwrapper">
        <div className="sidepanel">
          { loggedIn && <User /> }
          { <Navigation /> }
          <div className="sidepanel-spacer"></div>
          <div className="logo-wrapper">
            { this.renderLogo() }
          </div>
        </div>
        <div className="mainpanel ">
          { this.renderMainPanel() }
        </div>
        <Modal/>
        <NotificationStack/>
      </div>
    )
  }


  getClassName() {
    //const { user } = this.props
    let clsArr = ["app", "component"]
    //if (user.isSuperUser) clsArr.push("superuser")
    return clsArr.join(' ')
  }

  renderView() {
    const { view } = this.props
    switch(view) {
      case VIEW.LOGIN: return <Login/>
      case VIEW.PASSWORDRESET: return <PasswordReset/>
      default: return this.renderLayout()
    }
  }

  //
  render() {
    return (
      <div className="app-wrapper">
        <div className={ this.getClassName() }>
          { this.renderView() }
        </div>
        <CookieOptIn />
      </div>
    )
  }
}

App.propTypes = {}

const mapStateToProps = (state) => selector(state)

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
      {
        fetchUser,
        fetchLanguage,
        setView
      },
      dispatch
    )
}

const reduxComponent = connect(mapStateToProps, mapDispatchToProps)(App)
export default translate([], { withRef: true })(reduxComponent)



// WEBPACK FOOTER //
// ./src/app/component/app/index.jsx